module.exports = __webpack_public_path__ + "media/images/mother-day/motherday-template-ge-38bf6a9ba4b05903ca339057be9c0400.png";